import React, { useEffect, useState } from 'react';
import { Popper } from 'react-popper';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import CollapsibleMenu from './CollapsibleMenu/CollapsibleMenu';
import UnCollapsibleMenu from './UnCollapsibleItem/UnCollapsibleMenu';
import { ReactComponent as HQLogo } from 'assets/images/hqlogo.svg';
import NotificationSettings from './notificationSettings/NotificationSettings';
import { ReactComponent as PenIcon } from 'assets/images/penIcon.svg';
import sideNavData from 'dummy-data/sidenav-details.json';
import './SideNavBar.scss';
import EmployeeRegistration from 'assets/images/employeeRegistration.svg';
import EmployeeRegistrationSelected from 'assets/images/employeeRegistrationSelected.svg';

import Dashboard from 'assets/images/dashboard.svg';
import Close from 'assets/images/notificationClose.svg';
import DashboardSelected from 'assets/images/dashboardSelected.svg';
import CalendarSelected from 'assets/images/calenderSelected.svg';
import StaffList from 'assets/images/staffList.svg';
import StaffListSelected from 'assets/images/staffListSelected.svg';
import Time from 'assets/images/time.svg';
import TimeSelected from 'assets/images/timeSelected.svg';
import CheckList from 'assets/images/checkList.svg';
import CheckListSelected from 'assets/images/checkListSelected.svg';
import Journal from 'assets/images/journal.svg';
import JournalSelected from 'assets/images/journalSelected.svg';
import Calender from 'assets/images/calender.svg';
import Wand from 'assets/images/wand.svg';
import WandSelected from 'assets/images/wandSelected.svg';
import Notification from 'assets/images/notificationIcon.svg';
import { IRootState } from 'state/store';
import { removeNotification, removeAllNotifications } from 'state/notificationSlice';
import useStoreStore from 'zustands/useStoreStore';
import useUserStore from 'zustands/useUserStore';

type menuItems = {
  text: string;
  link: string;
  image?: any;
};

type SideNavData = {
  type: string;
  link?: string;
  titleText: string;
  menuItems?: menuItems[];
};

type NotificationItem = {
  id: number;
  title: string;
  date: string;
  content: string;
};

const SideNavBar: React.FC = () => {
  const navigate = useNavigate();

  const { storeName ,isBN } = useStoreStore();
  const { userType } = useUserStore();

  const icons = [Dashboard, EmployeeRegistration, StaffList, Time, CheckList, Journal, Calender, Wand];
  const iconsSelected = [
    DashboardSelected,
    EmployeeRegistrationSelected,
    StaffListSelected,
    TimeSelected,
    CheckListSelected,
    JournalSelected,
    CalendarSelected,
    WandSelected,
  ];
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dispatch = useDispatch();

  const notifications = useSelector((state: IRootState) => state.notifications);

  const togglePopover = () => {
    if (!notifications.notifications.length) {
      setIsOpen(false);
    } else {
      setIsOpen(!isOpen);
    }
  };

  const modifyStore = () => {
    navigate(`/business-establishment-choice-update`);
  };

  useEffect(() => {
    if (!notifications.notifications.length) {
      setIsOpen(false);
    }
  }, [notifications.notifications.length]);

  return (
    <div className="sideNavBarComponent">
      <div className="headerInfo">
        <div className="logoArea">
          <div className="HQLogo">
            <HQLogo />
          </div>
          <div className="logoData">
          {<div className={`w-fit px-2 rounded-[4px] font-normal text-[12px] mb-1  ${isBN ? 'bg-[#51939A] text-white' : 'bg-[#E6E7E8] text-[#7C7979]'} `}>{isBN ? '사업장인증' : '사업장 미인증 '}</div>}
            <strong>{storeName}</strong>

            {/* <div className="dateCountDown">무료체험 D-{sideNavData.remainingDays}</div> */}
          </div>
        </div>
        {userType === '1' && (
          <button className="image" onClick={modifyStore} title="사업장 수정하기">
            <PenIcon />
          </button>
        )}
      </div>

      <div className="divider"></div>
      {sideNavData.sideNavItems.map((row: SideNavData, i) => {
        if (row.type === 'collapsible') {
          return (
            <CollapsibleMenu
              key={`sideBarMenu_collapsible_${row.titleText}`}
              titleText={row.titleText}
              menuItems={userType === '1' ? row.menuItems : row.menuItems?.filter((i) => i.text !== '급여명세서 발급')}
              image={String(icons[i])}
              selectedImage={String(iconsSelected[i])}
            />
          );
        } else {
          return (
            <UnCollapsibleMenu
              key={`sideBarMenu_unCollapsible_${row.titleText}`}
              titleText={row.titleText}
              link={String(row.link)}
              image={String(icons[i])}
              selectedImage={String(iconsSelected[i])}
            />
          );
        }
      })}
      {isOpen && (
        <Popper placement="left">
          {({ ref, placement }) => (
            <div ref={ref} data-placement={placement} className="popoverStyles">
              <div className="headerRow">
                <div className="left">새로운 알림</div>
                <div
                  className="right"
                  onClick={() => {
                    dispatch(removeAllNotifications());
                  }}>
                  전체읽음
                </div>
              </div>

              <div className="contentList">
                {notifications.notifications.map((notification: NotificationItem) => {
                  return (
                    <div key={`sideBar_notification_${notification.id}`} className="notificationItem">
                      <div className="titleRow">
                        <div className="left">
                          <div className="title">{notification.title}</div>
                          <div className="date">{notification.date}</div>
                        </div>
                        <div
                          className="right"
                          onClick={() => {
                            dispatch(removeNotification({ id: notification.id }));
                          }}>
                          <img src={Close} alt="" />
                        </div>
                      </div>
                      <div className="notificationText">{notification.content}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </Popper>
      )}
    </div>
  );
};

export default SideNavBar;
